import CookieBannerUtils from '../../utils/ols-core/CookieBannerUtils';

export const track = ({ eid, type, params } = {}) => {
  if (!CookieBannerUtils.isAccepted) { return null; }

  window._trfq = window._trfq || [];

  return window._trfq.push([
    'cmdLogEvent',
    type,
    'pandc.ols.widget.' + eid,
    params || []
  ]);
};
